import React, { ReactNode } from "react"
import { Box, Flex, FlexProps } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import { Update } from "./types"
import { updateType } from "./utils"
import { WHATS_NEW_COLORS } from "./colors"

// d.io's chips (dio-marketing updates/_components/tag.tsx): types carry their colour as a dot,
// tags a tag outline and no colour, so the two never read alike

const Chip = ({ children }: { children: ReactNode }) => (
  <Flex
    as="li"
    align="center"
    gap="6px"
    h="24px"
    px="10px"
    borderWidth="1px"
    borderColor={WHATS_NEW_COLORS.line}
    borderRadius="full"
    color={WHATS_NEW_COLORS.text2}
    fontSize="13px"
    lineHeight={1.45}
    whiteSpace="nowrap"
  >
    {children}
  </Flex>
)

type Props = Pick<Update, "types" | "tags"> & FlexProps

const WhatsNewChips = ({ types, tags, ...props }: Props) => {
  if (!types.length && !tags.length) {
    return null
  }

  return (
    <Flex as="ul" listStyleType="none" wrap="wrap" gap={2} aria-label="Types and tags" {...props}>
      {types.map((slug) => {
        const type = updateType(slug)

        return (
          <Chip key={slug}>
            <Box aria-hidden boxSize="6px" flexShrink={0} borderRadius="full" bg={type?.color} />
            {type?.name}
          </Chip>
        )
      })}
      {tags.map(({ slug, name }) => (
        <Chip key={slug}>
          <Icon icon="tag-outline" size={3} color={WHATS_NEW_COLORS.text3} />
          {name}
        </Chip>
      ))}
    </Flex>
  )
}

export default WhatsNewChips
